import {
    addPermissionToTeamFail,
    addPermissionToTeamSuccess,
    deletePermissionFromTeamFail,
    deletePermissionFromTeamSuccess
} from './actions';
import { put } from 'redux-saga/effects';
import {
    makeErrorPayload,
    makeSuccessPayload
} from '../../../../../../shared/helpers/payload.helper';
import {
    setErrorToast,
    setSuccessToast
} from '../../../../../../shared/toast/redux/actions';
import { fetchTeams } from '../teams-list/actions';
import { addPermissionToTeam, deletePermissionFromTeam } from '../team.backend';
import { PermissionPipe } from '../../../../../../shared/pipes/PermissionPipe';

export function* addPermissionToTeamSaga(action) {
    const { teamId, permission } = action.payload;
    try {
        const response = yield addPermissionToTeam(teamId, { permission });
        yield put(addPermissionToTeamSuccess(response.data));
        yield put(
            setSuccessToast(
                makeSuccessPayload(
                    'Permission "' + PermissionPipe(permission) + '" added.'
                )
            )
        );
        yield put(fetchTeams());
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(addPermissionToTeamFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}

export function* deletePermissionFromTeamSaga(action) {
    const { teamId, permission } = action.payload;
    try {
        const response = yield deletePermissionFromTeam(teamId, permission);
        yield put(deletePermissionFromTeamSuccess(response.data));
        yield put(
            setSuccessToast(
                makeSuccessPayload(
                    'Permission "' + PermissionPipe(permission) + '" removed.'
                )
            )
        );
        yield put(fetchTeams());
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(deletePermissionFromTeamFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
